import { __commonJSMin as e } from "../../../../../../../../../_virtual/_rolldown/runtime.js";
import { require_html_block as t } from "./html-block.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0_canvas@3.2.0_/node_modules/@intercom/intercom-sanitizer/dist/html/config/email-template.js
var n = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.EMAIL_TEMPLATE_CONFIG = void 0;
	var n = t();
	e.EMAIL_TEMPLATE_CONFIG = Object.assign({}, n.HTML_BLOCK_CONFIG, { WHOLE_DOCUMENT: !0 });
}));
//#endregion
export default n();
export { n as require_email_template };
